/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.offerings.create.details.modals.autorenew.controllers', [])

.controller('MembershipOfferingsCreateDetailsModalsAutorenewController', ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {

    $scope.membershipOfferingsCreateDetailsModalsAutorenew = {

      model: {},

      title: 'Cannot Deactivate Auto Renew',
      description: 'This offering cannot be changed because it has active subscribers.',
      doneText: 'OK',

      init: function() {},

      close: function() {
        $uibModalInstance.dismiss('cancel');
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.membershipOfferingsCreateDetailsModalsAutorenew.init();

}]);
